import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type Post } from '@src/services/interface';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

type LinkFeedProps = {
    content: Post | null | undefined;
};

const LinkFeed = ({ content }: LinkFeedProps) => {
    const linkTitle = content?.link?.title || '';
    const linkSource = content?.link?.source || '';
    const linkThumbnail = content?.link?.thumbnail || '';
    const linkType = content?.link?.type || '';
    // @ts-ignore
    const linkUrl = content?.link.shareUrl || content?.link?.url || '';
    const hasVideo = linkType === 'video' || linkType === 'phtvsolenewslist';

    return linkTitle ? (
        <div className={styles.articleProphesy}>
            <div
                className={styles.feed}
                onClick={() => {
                    window.location.href = linkUrl;
                }}>
                {linkThumbnail && linkThumbnail && (
                    <div className={styles.picBox}>
                        <img className={styles.pic} src={formatImageWebpAuto(linkThumbnail, 90, 90)} />
                        {hasVideo && <div className={styles.videoIcon} />}
                    </div>
                )}
                <div className={styles.postRight}>
                    <div className={styles.postTitle}>{linkTitle}</div>
                    {linkSource && <div className={styles.postSource}>{linkSource}</div>}
                </div>
            </div>
        </div>
    ) : null;
};

export default errorBoundary(LinkFeed);
